import { Component, OnInit, inject } from '@angular/core';
import { PostTradeService } from '../../post-trade.service';
import { CaseManagementService } from '../../../case-management/case-management.service';
import { TradeGridSummaryResponse } from '../../../models/post-trade-models';

@Component({
  selector: 'app-account-review-dashboard',
  templateUrl: './account-review-dashboard.component.html',
  styleUrls: ['./account-review-dashboard.component.scss'],
  standalone: false,
})
export class AccountReviewDashboardComponent implements OnInit {
  private ptSvc = inject(PostTradeService);
  cms = inject(CaseManagementService);

  agingCases = [];
  openRecords = {};

  ngOnInit(): void {
    this.ptSvc.loading.set(true);
    this.cms
      .getCaseManagementData({
        search: {
          profileValues: {
            StatusName: 'Assigned',
            Type: ['Account', 'AccountGroup'],
          },
        },
        take: 10,
        sort: {
          DateLastUpdated: 'asc',
        },
      })
      .subscribe(resp => {
        if (resp['data']) {
          this.agingCases = resp['data'];
        }

        if (this.ptSvc.loading()) {
          this.ptSvc.loading.set(false);
        }
      });

    this.ptSvc
      .getAccountGridSummary()
      .subscribe((resp: TradeGridSummaryResponse) => {
        if (resp.data) {
          this.openRecords = resp.data[0];
        }

        if (this.ptSvc.loading()) {
          this.ptSvc.loading.set(false);
        }
      });
  }
}
